export default {
  // 通用
  'crm.common.actions': '操作',
  'crm.common.view': '查看',
  'crm.common.edit': '编辑',
  'crm.common.delete': '删除',
  'crm.common.create': '创建',
  'crm.common.save': '保存',
  'crm.common.cancel': '取消',
  'crm.common.confirm': '确认',
  'crm.common.search': '搜索',
  'crm.common.reset': '重置',
  'crm.common.status': '状态',
  'crm.common.createdAt': '创建时间',
  'crm.common.updatedAt': '更新时间',
  'crm.common.enable': '启用',
  'crm.common.disable': '禁用',
  'crm.common.yes': '是',
  'crm.common.no': '否',
  'crm.common.all': '全部',
  'crm.common.loading': '加载中...',
  'crm.common.noData': '暂无数据',
  'crm.common.total': '共计',
  'crm.common.selected': '已选择',
  'crm.common.items': '项',
  'crm.common.export': '导出',
  'crm.common.import': '导入',
  'crm.common.refresh': '刷新',
  'crm.common.back': '返回',
  'crm.common.detail': '详情',
  'crm.common.title': '标题',
  'crm.common.success': '操作成功',
  'crm.common.createFailed': '创建失败',
  'crm.common.updateFailed': '更新失败',
  'crm.common.deleteFailed': '删除失败',
  'crm.common.operationFailed': '操作失败',
  'crm.common.onlyImageAllowed': '只能上传图片文件',
  'crm.common.imageTooLarge': '图片大小不能超过5MB',
  'crm.timezone.local': '本地',
  'crm.timezone.utc': 'UTC',
  'crm.timezone.tooltip': '切换时间显示时区',

  // 仪表盘
  'crm.dashboard.title': '仪表盘',
  'crm.dashboard.totalUsers': '总用户数',
  'crm.dashboard.paidUsers': '付费用户',
  'crm.dashboard.activeMiners': '活跃矿机',
  'crm.dashboard.pendingWithdrawals': '待处理提现',
  'crm.dashboard.userGrowth': '用户增长（7天）',
  'crm.dashboard.revenueTrend': '收入趋势（USDT）（7天）',
  'crm.dashboard.userDistribution': '用户分布',
  'crm.dashboard.recentActivities': '最近活动',
  'crm.dashboard.fromYesterday': '较昨日',
  'crm.dashboard.paidRate': '付费率',
  'crm.dashboard.thisWeek': '本周',
  'crm.dashboard.total': '总计',
  'crm.dashboard.minerTypesDistribution': '矿机类型分布',
  'crm.dashboard.standardType': '普通型',
  'crm.dashboard.newUserType': '新用户型',
  'crm.dashboard.recentWithdrawals': '最近提现',
  'crm.dashboard.viewAll': '查看全部',
  'crm.dashboard.todayRevenue': '今日收入',
  'crm.dashboard.todayRegistrations': '今日注册',
  'crm.dashboard.activeSessions': '活跃会话',
  'crm.dashboard.todayStartedSessions': '今日开启挖矿',
  'crm.dashboard.claimableSessions': '挖矿待领取',
  'crm.dashboard.totalCommissionPaid': '累计佣金支出',
  'crm.dashboard.todayRefunds': '今日退款',
  'crm.dashboard.totalRefunds': '累计退款',
  'crm.dashboard.refundOrders': '退款订单',
  'crm.dashboard.vsYesterday': '较昨日',
  'crm.dashboard.miningNow': '正在挖矿',
  'crm.dashboard.thisMonth': '本月',
  'crm.dashboard.refresh': '刷新',
  'crm.dashboard.loadFailed': '加载仪表盘数据失败',
  'crm.dashboard.noPendingWithdrawals': '暂无待处理提现',
  // 平台指标
  'crm.dashboard.platformOverview': '平台概览',
  'crm.dashboard.totalRevenue': '累计总收入',
  'crm.dashboard.totalWithdrawn': '累计总提现',
  'crm.dashboard.platformBtcBalance': '平台 BTC 余额',
  'crm.dashboard.platformBtcBalanceDesc': '所有用户账户 BTC 余额之和',
  'crm.dashboard.totalHashrate': '全网总算力',
  'crm.dashboard.todayBtcOutput': '今日 BTC 产出',
  'crm.dashboard.wau': '周活跃用户 (WAU)',
  'crm.dashboard.wauDesc': '近7天有挖矿活动的用户',
  'crm.dashboard.arpu': 'ARPU',
  'crm.dashboard.arpuDesc': '人均收入（总收入 / 付费用户）',
  'crm.dashboard.minersExpiringSoon': '矿机到期预警',
  'crm.dashboard.minersExpiringSoonDesc': '7天内到期的矿机数',
  'crm.dashboard.referralRate': '推荐注册占比',
  'crm.dashboard.referralRateDesc': '通过推荐码注册的用户占比',
  'crm.dashboard.userActivity': '用户概览',
  'crm.dashboard.miningHealth': '挖矿健康度',
  'crm.dashboard.financeTitle': '财务概览',
  'crm.dashboard.retentionRate': '留存率统计',
  'crm.dashboard.retentionRateDesc': '注册第N天的活跃比例',
  'crm.dashboard.paymentRateTitle': '付费率统计',
  'crm.dashboard.paymentRateDesc': '注册后N天内首次付费比例',
  'crm.dashboard.noData': '暂无数据',
  'crm.dashboard.cohortDate': '日期',
  'crm.dashboard.cohortRegistrations': '注册人数',
  'crm.dashboard.cohortDayLabel': '{days}日',

  // 数据分析（群组分析）
  'crm.analytics.title': '数据分析',
  'crm.analytics.retentionRate': '留存率统计',
  'crm.analytics.retentionRateDesc': '注册第N天的活跃比例',
  'crm.analytics.paymentRate': '付费率统计',
  'crm.analytics.paymentRateDesc': '注册后N天内首次付费比例',
  'crm.analytics.roi': 'ROI 分析',
  'crm.analytics.roiDesc':
    'ROI = 收益 / 成本（投入产出比，≥1 表示回本）。收益数据来自注册后N天内的已完成订单。',
  'crm.analytics.cost': '成本',
  'crm.analytics.costPerUser': '单用户获客成本',
  'crm.analytics.defaultCost': '默认成本',
  'crm.analytics.costUpdated': '成本已更新',
  'crm.analytics.noData': '暂无数据',
  'crm.analytics.loadFailed': '加载分析数据失败',
  'crm.analytics.date': '日期',
  'crm.analytics.registrations': '注册人数',
  'crm.analytics.dayLabel': '{days}日',

  // 渠道统计
  'crm.channels.title': '渠道统计',
  'crm.channels.overview': '渠道概览',
  'crm.channels.trend': '注册趋势（近30天）',
  'crm.channels.channel': '渠道',
  'crm.channels.visits': '访问次数',
  'crm.channels.totalVisits': '总访问',
  'crm.channels.todayVisits': '今日访问',
  'crm.channels.totalUsers': '总用户数',
  'crm.channels.todayUsers': '今日新增',
  'crm.channels.last7dUsers': '近7天',
  'crm.channels.last30dUsers': '近30天',
  'crm.channels.paidUsers': '付费用户',
  'crm.channels.paidRate': '付费率',
  'crm.channels.totalRevenue': '总收入 (USDT)',
  'crm.channels.arpu': 'ARPU',
  'crm.channels.direct': '直接访问',
  'crm.channels.loadFailed': '加载渠道数据失败',
  'crm.channels.noData': '暂无数据',
  'crm.channels.totalChannels': '渠道数量',
  'crm.channels.totalRegistrations': '总注册',
  'crm.channels.totalPaidUsers': '总付费用户',
  'crm.channels.overallPaidRate': '整体付费率',

  // 用户管理
  'crm.users.title': '用户管理',
  'crm.users.list': '用户列表',
  // 老系统用户 Excel 导入
  'crm.users.import.entry': '导入用户',
  'crm.users.import.title': '从 Excel 导入老系统用户',
  'crm.users.import.helpTitle': '导入说明',
  'crm.users.import.helpDesc':
    '导入流程与新用户注册一致：账号统一登记为 Google 登录（无需密码），并按系统设置赠送一台新用户矿机；BTC 余额直接迁移到账户。不会创建挖矿会话和交易记录。Excel 必须包含表头列：email、btcBalance；可选列：registeredAt（注册时间，写入 user.createdAt，留空则使用当前时间）。',
  'crm.users.import.registeredAt': '注册时间',
  'crm.users.import.dragText': '点击或拖入 Excel 文件（.xlsx / .xls）',
  'crm.users.import.dragHint': '单次最多 2000 行；CRM 端会先解析后再提交，可在下方预览。',
  'crm.users.import.downloadTemplate': '下载模板',
  'crm.users.import.parsedCount': '已解析 {count} 行',
  'crm.users.import.parseErrors': '解析异常 {count} 行',
  'crm.users.import.missingHeaders': '缺少必填列：{fields}',
  'crm.users.import.noRows': '没有可提交的行',
  'crm.users.import.submitBtn': '导入 {count} 条',
  'crm.users.import.summary':
    '导入完成：成功 {success} / 跳过 {skipped} / 失败 {failed}',
  'crm.users.import.resultTitle':
    '总数 {total}，成功 {success}，已存在跳过 {skipped}，失败 {failed}',
  'crm.users.detail': '用户详情',
  'crm.users.dragToResize': '拖动以调整宽度',
  'crm.users.uid': '用户ID',
  'crm.users.nickname': '昵称',
  'crm.users.email': '邮箱',
  'crm.users.authMethod': '登录方式',
  'crm.users.status': '状态',
  'crm.users.isPaid': '付费状态',
  'crm.users.paid': '已付费',
  'crm.users.free': '免费',
  'crm.users.balance': '余额',
  'crm.users.btcBalance': 'BTC 余额',
  'crm.users.bldBalance': 'BLD 余额',
  'crm.users.referrals': '推荐人数',
  'crm.users.commission': '佣金',
  'crm.users.registeredAt': '注册时间',
  'crm.users.registeredAtRange': '注册时间段',
  'crm.users.searchReferredByUid': '邀请人ID',
  'crm.users.searchReferredByCode': '上级邀请码',
  'crm.users.active': '正常',
  'crm.users.inactive': '未激活',
  'crm.users.disabled': '已禁用',
  'crm.users.banned': '已封禁',
  'crm.users.adjustBalance': '调整余额',
  'crm.users.adjustBalanceTitle': '调整用户余额',
  'crm.users.adjustAmount': '调整金额',
  'crm.users.adjustAmountHint': '正数为增加，负数为扣减',
  'crm.users.adjustReason': '原因',
  'crm.users.basicInfo': '基本信息',
  'crm.users.acceptCommission': '接受佣金',
  'crm.users.acceptCommissionDesc':
    '关闭后，该用户作为推荐人时不再获得下级的返佣（仅跳过自身，仍会继续向其上级发放）',
  'crm.users.upwardCommission': '向上返佣',
  'crm.users.upwardCommissionDesc':
    '关闭后，该用户购买商品 / 领取挖矿收益时将不再向任何上级发放返佣（整条链切断）',
  'crm.users.referralFlagUpdated': '已更新返佣开关',
  'crm.users.referralFlagUpdateFailed': '更新返佣开关失败',
  'crm.users.referralStats': '推荐统计',
  'crm.users.totalReferrals': '总推荐数',
  'crm.users.level1Referrals': '一级推荐',
  'crm.users.level2Referrals': '二级推荐',
  'crm.users.level3Referrals': '三级推荐',
  'crm.users.totalCommission': '总佣金',
  'crm.users.transactions': '交易记录',
  'crm.users.miners': '矿机',
  'crm.users.mining': '挖矿',
  'crm.users.miningCurrent': '当前挖矿状态',
  'crm.users.miningStatusOn': '正在挖矿',
  'crm.users.miningStatusOff': '未挖矿',
  'crm.users.miningClaimable': '待领取会话数',
  'crm.users.miningTotalClaimed': '累计已领取',
  'crm.users.miningClaimedCount': '已领取次数',
  'crm.users.miningTotalSessions': '总会话数',
  'crm.users.miningStatus': '状态',
  'crm.users.miningStatusMining': '挖矿中',
  'crm.users.miningStatusClaimable': '待领取',
  'crm.users.miningStatusClaimed': '已领取',
  'crm.users.miningStatusCancelled': '已取消',
  'crm.users.miningStartTime': '开始时间',
  'crm.users.miningEndTime': '结束时间',
  'crm.users.miningHashrate': '总算力',
  'crm.users.miningMinersCount': '矿机数',
  'crm.users.miningEstimatedYield': '预估收益',
  'crm.users.miningAccumulatedYield': '累计收益',
  'crm.users.miningActualYield': '实际领取',
  'crm.users.miningClaimedAt': '领取时间',
  'crm.users.viewUser': '查看用户',
  'crm.users.referralCode': '推荐码',
  'crm.users.referredBy': '推荐人',
  'crm.users.lastLogin': '最后登录',
  'crm.users.totalEarnings': '总收益',
  'crm.users.level1Users': '一级用户数',
  'crm.users.level1Commission': '一级佣金',
  'crm.users.level2Users': '二级用户数',
  'crm.users.level2Commission': '二级佣金',
  'crm.users.level3Users': '三级用户数',
  'crm.users.level3Commission': '三级佣金',
  'crm.users.loadFailed': '加载用户详情失败',
  'crm.users.adjustSuccess': '余额调整成功',
  'crm.users.adjustReasonPlaceholder': '请输入调整原因',
  'crm.users.totalDeposit': '总充值',
  'crm.users.totalWithdrawBTC': '总提现BTC',
  'crm.users.totalWithdrawUSDT': '总提现USDT',
  'crm.users.totalWithdrawFee': '提现手续费(BTC)',
  'crm.users.depositWithdrawStats': '充提统计',
  'crm.users.fissionCount': '裂变数量',
  'crm.users.hashrate': '算力',
  'crm.users.country': '国家',
  'crm.users.channel': '渠道',
  'crm.users.lastLoginIp': '最后登录IP',
  'crm.users.btcBalanceChanges': 'BTC 余额变动',
  'crm.users.directReferrals': '直推用户',
  'crm.users.fissionUsers': '裂变用户',
  'crm.users.fissionLevel': '层级',
  'crm.users.levelN': '第{n}层',

  // 矿机管理
  'crm.miners.title': '矿机管理',
  'crm.miners.products': '矿机产品',
  'crm.miners.addProduct': '添加产品',
  'crm.miners.editProduct': '编辑产品',
  'crm.miners.addMinerProduct': '添加矿机产品',
  'crm.miners.editMinerProduct': '编辑矿机产品',
  'crm.miners.model': '型号',
  'crm.miners.type': '类型',
  'crm.miners.typeStandard': '普通',
  'crm.miners.typeNewUser': '新用户',
  'crm.miners.hashrate': '算力',
  'crm.miners.hashrateUnit': '算力 (TH/s)',
  'crm.miners.price': '价格',
  'crm.miners.priceUSD': '价格 (USD)',
  'crm.miners.priceBTC': '价格 (BTC)',
  'crm.miners.cryptoDiscount': '数字货币折扣',
  'crm.miners.cryptoDiscountTip':
    '加密货币支付时使用的折扣系数（0~1，1 表示不打折）。例如填 0.95，10 USD 商品在加密支付时实际仅需 9.5 USD。仅作用于加密支付通道，Card / Google Play 仍按原价。',
  'crm.miners.dailyOutput': '日产量',
  'crm.miners.dailyOutputBTC': '日产量 (BTC)',
  'crm.miners.validDays': '有效天数',
  'crm.miners.yieldDailyBtc': '每日收益',
  'crm.miners.yieldHalfValidDaysBtc': '半周期收益',
  'crm.miners.yieldFullValidDaysBtc': '全周期收益',
  'crm.miners.yieldBtcHint':
    '以下为按系统「挖矿设置」中每 TH 每小时基础产出 × 24 小时估算的 BTC 参考值（随算力与有效天数变化）。',
  'crm.miners.yieldBtcLoading': '正在读取挖矿基础产出…',
  'crm.miners.yieldBtcLoadFailed':
    '无法读取系统挖矿基础产出，请确认有系统设置权限或稍后重试。',
  'crm.miners.yieldBtcPriceNote': '参考 BTC 价格：约 {price} USDT / 1 BTC',
  'crm.miners.yieldApproxUsdt': '（≈ {amount} USDT）',
  'crm.miners.days': '天',
  'crm.miners.available': '可用',
  'crm.miners.unavailable': '不可用',
  'crm.miners.image': '图片',
  'crm.miners.description': '描述',
  'crm.miners.totalProducts': '产品总数',
  'crm.miners.totalHashrate': '总算力',
  'crm.miners.expires': '到期时间',
  'crm.miners.purchased': '购买时间',
  'crm.miners.remark': '备注',
  'crm.miners.manufacturer': '制造商',
  'crm.miners.inventory': '库存',
  'crm.miners.sortOrder': '排序权重',
  'crm.miners.sortOrderTip':
    '列表展示权重；数值越大在 App 与 CRM 中越靠前。相同权重时按价格升序兜底。',
  'crm.miners.tags': '标签',
  'crm.miners.algorithm': '算法',
  'crm.miners.powerConsumption': '功耗 (W)',
  'crm.miners.deleteConfirm': '确定要删除此产品吗？',
  'crm.miners.createSuccess': '产品创建成功',
  'crm.miners.updateSuccess': '产品更新成功',
  'crm.miners.deleteSuccess': '产品删除成功',
  'crm.miners.enableSuccess': '产品启用成功',
  'crm.miners.disableSuccess': '产品禁用成功',
  'crm.miners.syncBagelPay': '配置 BagelPay',
  'crm.miners.bagelPaySyncing': '正在同步到 BagelPay...',
  'crm.miners.bagelPaySyncSuccess': 'BagelPay 产品配置成功',
  'crm.miners.bagelPaySyncFailed': 'BagelPay 产品配置失败',
  'crm.miners.tagHot': '热卖',
  'crm.miners.tagBestValue': '最佳性价比',
  'crm.miners.tagEntry': '入门级',
  'crm.miners.tagNew': '新品',
  'crm.miners.tagHighYield': '高收益',
  'crm.miners.tagFreeTrial': '免费试用',
  'crm.miners.uploadImage': '上传图片',
  'crm.miners.uploadImageTip': '点击或拖拽上传产品图片',
  'crm.miners.uploadSuccess': '图片上传成功',
  'crm.miners.uploadFailed': '图片上传失败',
  'crm.miners.addInventory': '增加库存',
  'crm.miners.addInventoryTitle': '增加产品库存',
  'crm.miners.addInventoryAmount': '增加数量',
  'crm.miners.addInventorySuccess': '库存增加成功',
  'crm.miners.addInventoryFailed': '增加库存失败',
  'crm.miners.reduceInventory': '减少库存',
  'crm.miners.reduceInventoryTitle': '减少产品库存',
  'crm.miners.reduceInventoryAmount': '减少数量',
  'crm.miners.reduceInventorySuccess': '库存减少成功',
  'crm.miners.reduceInventoryFailed': '减少库存失败',
  'crm.miners.currentInventory': '当前库存',
  'crm.miners.grantMiner': '发送矿机',
  'crm.miners.grantMinerTitle': '发放矿机给用户',
  'crm.miners.grantMinerSelect': '选择矿机产品',
  'crm.miners.grantMinerConfirm': '确定要将此矿机发放给该用户吗？',
  'crm.miners.grantMinerSuccess': '矿机发放成功',
  'crm.miners.grantMinerFailed': '矿机发放失败',
  'crm.miners.grantOrderMiner': '发送订单矿机',
  'crm.miners.grantOrderMinerTitle': '发送订单矿机（已支付订单）',
  'crm.miners.grantOrderMinerSuccess': '订单矿机已创建，订单号：{orderId}',
  'crm.miners.grantOrderMinerFailed': '订单矿机创建失败',
  'crm.miners.grantOrderPurchasedAt': '矿机购买时间',
  'crm.miners.grantOrderMinerStart': '矿机开始时间',
  'crm.miners.grantOrderMinerEnd': '矿机结束时间',
  'crm.miners.grantOrderMinerEndHint': '默认按矿机周期自动计算（开始时间 + 有效天数），可手动调整',
  'crm.miners.grantOrderPaymentMethod': '订单支付方式',
  'crm.miners.grantOrderPayAmount': '订单金额 (USDT)',
  'crm.miners.grantOrderPayAmountHint': '留空则使用产品价格 × 数量；可手工覆盖。',
  'crm.miners.paymentCrypto': '加密货币 (NOWPayments)',
  'crm.miners.paymentCard': '信用卡 (BagelPay)',
  'crm.miners.paymentGooglePay': 'Google Play 内购',

  // 提现管理
  'crm.withdrawals.title': '提现管理',
  'crm.withdrawals.pending': '待审核提现',
  'crm.withdrawals.history': '提现历史',
  'crm.withdrawals.id': 'ID',
  'crm.withdrawals.user': '用户',
  'crm.withdrawals.currency': '币种',
  'crm.withdrawals.network': '网络',
  'crm.withdrawals.address': '地址',
  'crm.withdrawals.amount': '金额',
  'crm.withdrawals.fee': '手续费',
  'crm.withdrawals.receiveAmount': '实收金额',
  'crm.withdrawals.status': '状态',
  'crm.withdrawals.statusPending': '待审核',
  'crm.withdrawals.statusApproved': '已批准',
  'crm.withdrawals.statusProcessing': '处理中',
  'crm.withdrawals.statusCompleted': '已完成',
  'crm.withdrawals.statusRejected': '已拒绝',
  'crm.withdrawals.txHash': '交易哈希',
  'crm.withdrawals.rejectReason': '拒绝原因',
  'crm.withdrawals.processedAt': '处理时间',
  'crm.withdrawals.processedBy': '处理人',
  'crm.withdrawals.approve': '批准',
  'crm.withdrawals.reject': '拒绝',
  'crm.withdrawals.batchApprove': '批量批准',
  'crm.withdrawals.rejectTitle': '拒绝提现',
  'crm.withdrawals.rejectPlaceholder': '请输入拒绝原因',
  'crm.withdrawals.pendingRequests': '待处理请求',
  'crm.withdrawals.totalPendingAmount': '待处理总额',
  'crm.withdrawals.btcPending': 'BTC 待处理',
  'crm.withdrawals.usdtPending': 'USDT 待处理',
  'crm.withdrawals.approveSuccess': '提现已通过审批',
  'crm.withdrawals.approveFailed': '审批失败',
  'crm.withdrawals.batchApproveFailed': '批量审批失败',
  'crm.withdrawals.rejectSuccess': '提现已拒绝',
  'crm.withdrawals.rejectFailed': '拒绝失败',
  'crm.withdrawals.approveConfirm': '确定通过此提现申请吗？',
  'crm.withdrawals.selectAtLeastOne': '请至少选择一条提现记录',
  'crm.withdrawals.batchApproveConfirm': '确定批量通过 {count} 条提现申请吗？',
  'crm.withdrawals.batchApproveSuccess': '已通过 {count} 条提现',
  // 手动转账（运营兜底）
  'crm.withdrawals.manualTransfer': '手动转账',
  'crm.withdrawals.manualTransferTitle': '手动转账并完成提现',
  'crm.withdrawals.manualTransferConfirm': '确认手动转账完成',
  'crm.withdrawals.manualTransferSuccess': '已标记为手动转账完成',
  'crm.withdrawals.manualTransferFailed': '手动转账操作失败',
  'crm.withdrawals.manualTransferWarningTitle': '请确认链上转账已实际完成',
  'crm.withdrawals.manualTransferWarningDesc':
    '此操作将直接把该提现标记为已完成（COMPLETED），并写入您填写的 txHash。系统不会再调用 chain-scan 出币，也不会动用用户余额（创建时已扣减）。仅在您确认已通过站外/运营钱包手动完成链上转账后使用。',
  'crm.withdrawals.manualTransferTxHash': '交易哈希 (TxHash)',
  'crm.withdrawals.manualTransferTxHashRequired': '请填写链上交易哈希',
  'crm.withdrawals.manualTransferTxHashExtra':
    '运营手动转账完成后，请填写真实链上 TxHash，便于用户与对账追溯。',
  'crm.withdrawals.manualTransferNote': '备注（可选）',
  'crm.withdrawals.manualTransferNotePlaceholder':
    '可填写本次手动转账的原因或上下文，例如：chain-scan 暂不可用，运营钱包代付。',

  // 活动管理
  'crm.activities.title': '活动管理',
  'crm.activities.dailyPool': '每日奖池',
  'crm.activities.social': '社交活动',
  'crm.activities.periodDate': '活动日期',
  'crm.activities.periodNumber': '期数',
  'crm.activities.reward': '奖励',
  'crm.activities.totalParticipants': '总参与人数',
  'crm.activities.qualifiedParticipants': '达标人数',
  'crm.activities.totalInvites': '总邀请数',
  'crm.activities.perUserReward': '人均奖励',
  'crm.activities.statusActive': '进行中',
  'crm.activities.statusSettled': '已结算',
  'crm.activities.statusUpcoming': '即将开始',
  'crm.activities.statusEnded': '已结束',
  'crm.activities.settledAt': '结算时间',
  'crm.activities.settings': '设置',
  'crm.activities.defaultReward': '默认奖励',
  'crm.activities.minInvitesToQualify': '最低邀请数',
  'crm.activities.todayPool': '今日奖池',
  'crm.activities.todayParticipants': '今日参与',
  'crm.activities.todayQualified': '今日达标',
  'crm.activities.totalDistributed': '累计发放',
  'crm.activities.todayProgress': '今日进度',
  'crm.activities.qualifiedRate': '达标率',
  'crm.activities.avgInvitesPerUser': '人均邀请',
  'crm.activities.estPerUser': '预计人均',
  'crm.activities.participants': '参与者',
  'crm.activities.invites': '邀请数',
  'crm.activities.qualified': '是否达标',
  'crm.activities.joinedAt': '参与时间',
  // 社交活动
  'crm.activities.twitter': 'Twitter 挑战',
  'crm.activities.youtube': 'YouTube 创作者',
  'crm.activities.createPeriod': '创建活动期',
  'crm.activities.eventType': '活动类型',
  'crm.activities.duration': '活动时间',
  'crm.activities.startTime': '开始时间',
  'crm.activities.endTime': '结束时间',
  'crm.activities.submissions': '提交数',
  'crm.activities.approved': '已通过',
  'crm.activities.pending': '待审核',
  'crm.activities.pendingReview': '待审核',
  'crm.activities.rejected': '已拒绝',
  'crm.activities.totalSubmissions': '总提交数',
  'crm.activities.link': '链接',
  'crm.activities.submittedAt': '提交时间',
  'crm.activities.reviewedAt': '审核时间',
  'crm.activities.viewLink': '查看链接',
  'crm.activities.rejectSubmission': '拒绝提交',
  'crm.activities.activePeriodReward': '当前活动奖励',
  'crm.activities.activeSubmissions': '当前活动提交数',
  'crm.activities.totalPeriods': '总活动期数',
  'crm.activities.rewardAmountBTC': '奖励金额 (BTC)',
  'crm.activities.approve': '通过',
  'crm.activities.reject': '拒绝',
  'crm.activities.approveSubmission': '通过提交',
  'crm.activities.approveSubmissionConfirm': '确定要通过此提交吗？',
  'crm.activities.approveSuccess': '提交已通过',
  'crm.activities.rejectReason': '拒绝原因',
  'crm.activities.rejectReasonRequired': '请输入拒绝原因',
  'crm.activities.rejectReasonPlaceholder': '请输入拒绝原因',
  'crm.activities.rejectSuccess': '提交已拒绝',
  'crm.activities.selectSubmissions': '请选择提交',
  'crm.activities.batchApprove': '批量通过',
  'crm.activities.batchApproveConfirm': '确定要通过 {count} 个提交吗？',
  'crm.activities.batchApproveSuccess': '{count} 个提交已通过',
  'crm.activities.periodInfo': '活动期信息',
  'crm.activities.rewardPool': '奖池',
  'crm.activities.dailyPoolHistory': '每日奖池历史',
  'crm.activities.dailyPoolSettings': '每日奖池设置',
  'crm.activities.dailyPoolDetail': '每日奖池详情',
  'crm.activities.qualifiedUsers': '达标用户',
  'crm.activities.statusPending': '待发放',
  'crm.activities.statusDistributed': '已发放',
  'crm.activities.distributedAmount': '发放金额',
  'crm.activities.distributedAt': '发放时间',
  'crm.activities.distribute': '发放',
  'crm.activities.distributeReward': '发放奖励',
  'crm.activities.distributeSettings': '发放设置',
  'crm.activities.distributeAmount': '发放数量',
  'crm.activities.distributeCurrency': '发放币种',
  'crm.activities.confirmDistribute': '确认发放',
  'crm.activities.distributeSuccess': '奖励发放成功',
  'crm.activities.rewardPreview': '奖励预览',
  'crm.activities.share': '份额',
  'crm.activities.pendingDistribute': '待发放期数',
  'crm.activities.todayInvites': '今日邀请数',
  'crm.activities.skipped': '已跳过',
  'crm.activities.skipTip': '勾选用户可跳过发放',
  'crm.activities.skippedCount': '已跳过 {count} 人',
  'crm.activities.fissionCount': '裂变数量',
  'crm.activities.linkType': '链接类型',
  'crm.activities.approvedUsers': '已通过用户',
  'crm.activities.distributeAmountRequired': '请输入发放数量',
  'crm.activities.socialEvents': '社交活动',
  'crm.activities.rewarded': '已发放',
  'crm.activities.totalRewarded': '累计发放人数',
  'crm.activities.totalRewardAmount': '累计发放金额',
  'crm.activities.rewardStatus': '奖励状态',
  'crm.activities.notRewarded': '未发放',
  'crm.activities.sendReward': '发放奖励',
  'crm.activities.confirmReward': '确认发放',
  'crm.activities.rewardAmount': '奖励数量',
  'crm.activities.rewardCurrency': '奖励币种',
  'crm.activities.rewardAmountRequired': '请输入奖励数量',
  'crm.activities.rewardSuccess': '奖励发放成功',
  'crm.activities.submittedLink': '提交的链接',
  'crm.activities.copyLink': '复制链接',
  'crm.activities.linkCopied': '链接已复制',
  'crm.activities.amountPositive': '金额必须为正数',
  'crm.activities.distributeFailed': '分配失败',
  'crm.activities.configUpdated': '配置已更新',
  'crm.activities.updateFailed': '更新失败',
  'crm.activities.rewardFailed': '奖励发放失败',
  'crm.activities.createFailed': '创建失败',

  // 交易记录
  'crm.transactions.title': '交易记录',
  'crm.transactions.type': '类型',
  'crm.transactions.typeDeposit': '充值',
  'crm.transactions.typeWithdraw': '提现',
  'crm.transactions.typePurchase': '购买',
  'crm.transactions.typeClaim': '领取',
  'crm.transactions.typeReferral': '推荐奖励',
  'crm.transactions.typeSwap': '兑换',
  'crm.transactions.typeEvent': '活动奖励',
  'crm.transactions.typePlatformReward': '平台奖励',
  'crm.transactions.amount': '金额',
  'crm.transactions.description': '描述',
  'crm.transactions.statusPending': '处理中',
  'crm.transactions.statusCompleted': '已完成',
  'crm.transactions.statusFailed': '失败',
  'crm.transactions.time': '时间',
  'crm.transactions.todayTransactions': '今日交易数',
  'crm.transactions.todayVolume': '今日交易量',
  'crm.transactions.todayIncome': '今日收入',
  'crm.transactions.totalTransactions': '总交易数',
  'crm.transactions.allTransactions': '全部交易',
  'crm.transactions.user': '用户',
  'crm.transactions.status': '状态',
  'crm.transactions.actions': '操作',
  'crm.transactions.viewUser': '查看用户',
  'crm.transactions.loadFailed': '加载交易记录失败',
  'crm.transactions.loadUserFailed': '加载用户详情失败',

  // 订单管理
  'crm.orders.title': '订单管理',
  'crm.orders.list': '订单列表',
  'crm.orders.orderId': '订单ID',
  'crm.orders.userId': '用户ID',
  'crm.orders.email': '邮箱',
  'crm.orders.type': '类型',
  'crm.orders.typeMiner': '矿机',
  'crm.orders.typeLottery': '奖券',
  'crm.orders.speed': '速度',
  'crm.orders.payAmount': '支付金额',
  'crm.orders.status': '订单状态',
  'crm.orders.statusPending': '待支付',
  'crm.orders.statusPaid': '支付成功',
  'crm.orders.statusCancelled': '取消支付',
  'crm.orders.statusExpired': '已过期',
  'crm.orders.isFirstOrder': '首单',
  'crm.orders.isFirst': '是',
  'crm.orders.notFirst': '否',
  'crm.orders.isPromoOrder': '活动订单',
  'crm.orders.promoTag': '促销',
  'crm.orders.originalPrice': '原价',
  'crm.orders.discountPercent': '折扣',
  'crm.orders.createdAt': '下单时间',
  'crm.orders.createdAtRange': '创建时间',
  'crm.orders.orderIdSearchPlaceholder': '订单号 / Google 订单号 (GPA.xxx)',
  'crm.orders.expiredAt': '过期时间',
  'crm.orders.totalOrders': '总订单数',
  'crm.orders.pendingOrders': '待支付订单',
  'crm.orders.paidOrders': '已支付订单',
  'crm.orders.expiredOrders': '已过期订单',
  'crm.orders.todayOrders': '今日订单',
  'crm.orders.todayPaid': '今日支付',
  'crm.orders.totalAmount': '总金额',
  'crm.orders.expirationTime': '过期时间（1小时未支付）',
  'crm.orders.productName': '产品名称',
  'crm.orders.quantity': '数量',
  'crm.orders.detail': '订单详情',
  'crm.orders.payCurrency': '支付币种',
  'crm.orders.payAmountCrypto': '加密货币金额',
  'crm.orders.paymentMethod': '支付方式',
  'crm.orders.payAddress': '收款地址',
  'crm.orders.network': '网络',
  'crm.orders.nowPaymentId': 'NOWPayments ID',
  'crm.orders.paidAt': '支付时间',
  'crm.orders.orderInfo': '订单信息',
  'crm.orders.paymentInfo': '支付信息',
  'crm.orders.completeAction': '完成订单',
  'crm.orders.completeTitle': '手动完成订单',
  'crm.orders.completeConfirm': '确认完成',
  'crm.orders.completeTip':
    '用于"用户已实际付款但 IPN 回调未到"的兜底场景。请确认款项已收到，再执行该操作。',
  'crm.orders.completeSuccess': '订单已完成',
  'crm.orders.completeFailed': '订单完成失败',
  'crm.orders.grantMiner': '同时发放矿机',
  'crm.orders.grantMinerOnDesc':
    '将按购买流程：扣减库存、生成矿机并绑定到对应 Farm、累计算力，并发放推荐返佣。',
  'crm.orders.grantMinerOffDesc':
    '不再发放矿机（适用于已通过"赠送矿机"等手段先行手动发货的场景），仅把订单标记为已支付并写入交易记录，不重复扣库存、不发放推荐返佣。',

  // 票券商品管理
  'crm.tickets.title': '票券管理',
  'crm.tickets.products': '票券商品',
  'crm.tickets.addProduct': '添加票券套餐',
  'crm.tickets.editProduct': '编辑票券套餐',
  'crm.tickets.name': '套餐名称',
  'crm.tickets.ticketAmount': '票券数量',
  'crm.tickets.bonusAmount': '赠送数量',
  'crm.tickets.totalAmount': '总数量',
  'crm.tickets.price': '售价 (USDT)',
  'crm.tickets.originalPrice': '原价 (USDT)',
  'crm.tickets.tag': '标签',
  'crm.tickets.sortOrder': '排序',
  'crm.tickets.available': '已上架',
  'crm.tickets.unavailable': '已下架',
  'crm.tickets.deleteConfirm': '确定要删除此票券套餐吗？',
  'crm.tickets.createSuccess': '票券套餐创建成功',
  'crm.tickets.updateSuccess': '票券套餐更新成功',
  'crm.tickets.deleteSuccess': '票券套餐删除成功',
  'crm.tickets.enableSuccess': '票券套餐已上架',
  'crm.tickets.disableSuccess': '票券套餐已下架',
  'crm.tickets.namePlaceholder': '如 Basic, Premium',
  'crm.tickets.tagPlaceholder': '如 +5 Bonus, HOT',

  // 站内信管理
  'crm.messages.title': '站内信管理',
  'crm.messages.list': '消息列表',
  'crm.messages.send': '发送消息',
  'crm.messages.type': '消息类型',
  'crm.messages.typeSystem': '系统消息',
  'crm.messages.typeActivity': '活动消息',
  'crm.messages.typePersonal': '个人消息',
  'crm.messages.messageTitle': '标题',
  'crm.messages.messageContent': '内容',
  'crm.messages.sendTarget': '发送对象',
  'crm.messages.allUsers': '全体用户（系统广播）',
  'crm.messages.specifiedUser': '指定用户',
  'crm.messages.paidUsers': '付费用户',
  'crm.messages.withdrawnUsers': '提现用户',
  'crm.messages.activeUsers': 'N天日活用户',
  'crm.messages.activeDays': '活跃天数',
  'crm.messages.activeDaysPlaceholder':
    '请输入天数（如 7 表示最近7天活跃用户）',
  'crm.messages.activeDaysRequired': '请输入活跃天数',
  'crm.messages.targetUser': '目标用户',
  'crm.messages.searchUser': '搜索用户昵称、UID 或邮箱',
  'crm.messages.sentBy': '发送者',
  'crm.messages.sendTime': '发送时间',
  'crm.messages.deleteConfirm': '确认删除',
  'crm.messages.deleteConfirmContent': '删除后无法恢复，确认删除该消息？',
  'crm.messages.deleteSuccess': '删除成功',
  'crm.messages.deleteFailed': '删除失败',
  'crm.messages.sendSuccess': '消息发送成功，已同步推送通知',
  'crm.messages.sendFailed': '发送失败',
  'crm.messages.titleRequired': '请输入标题',
  'crm.messages.titleMaxLength': '标题最多 200 字',
  'crm.messages.contentRequired': '请输入内容',
  'crm.messages.contentMaxLength': '内容最多 10000 字',
  'crm.messages.selectUser': '请选择目标用户',
  'crm.messages.selectType': '请选择消息类型',
  'crm.messages.titlePlaceholder': '消息标题',
  'crm.messages.contentPlaceholder': '消息内容',
  'crm.messages.sendButton': '发送',
  'crm.messages.noMessages': '暂无消息',

  // 钱包连接
  'crm.wallets.title': '钱包连接列表',
  'crm.wallets.address': '钱包地址',
  'crm.wallets.chain': '链',
  'crm.wallets.connectedAt': '连接时间',
  'crm.wallets.lastActive': '最后活跃',
  'crm.wallets.connected': '已连接',
  'crm.wallets.disconnected': '已断开',
  'crm.users.wallets': '钱包连接',

  // 点击统计
  'crm.clickStats.title': '点击统计',
  'crm.clickStats.totalClicks': '总点击',
  'crm.clickStats.convertedClicks': '已转化',
  'crm.clickStats.conversionRate': '转化率',
  'crm.clickStats.recentClicks': '近期点击',
  'crm.clickStats.days': '天',
  'crm.clickStats.uniqueUsers': '独立用户',
  'crm.clickStats.dailyTrend': '每日趋势',

  // 系统设置
  'crm.settings.title': '系统设置',
  'crm.settings.mining': '挖矿设置',
  'crm.settings.referral': '推荐设置',
  'crm.settings.dailyPool': '每日奖池',
  'crm.settings.socialEvents': '社交活动',
  'crm.settings.pwaReward': 'PWA 奖励',
  'crm.settings.pwaRewardConfig': 'PWA 安装奖励',
  'crm.settings.pwaRewardConfigDesc':
    '用户安装 PWA 应用后自动发放 BTC 奖励，每个用户仅限领取一次。',
  'crm.settings.enablePwaReward': '启用 PWA 安装奖励',
  'crm.settings.pwaRewardAmount': '奖励金额 (BTC)',
  'crm.settings.pwaCutoffDate': '注册截止日期',
  'crm.settings.pwaCutoffDateDesc':
    '在此日期之前注册的用户不能获得PWA奖励，活动页面也不会展示PWA活动',
  'crm.settings.payment': '支付配置',
  'crm.settings.paymentEnabled': '启用 NOWPayments 支付',
  'crm.settings.refundClawbackEnabled': '退款追扣 BTC 收益',
  'crm.settings.refundClawbackEnabledTip':
    '启用后，订单退款时会按已领取的挖矿收益反向冲账（余额可能变为负数并冻结提现）。关闭后退款仅停机，不扣回已领取的 BTC 收益。',
  'crm.settings.paymentEnabledTip':
    '关闭后，Web 前端将显示"支付通道正在升级"提示，用户无法购买',
  'crm.settings.bagelPayEnabled': '启用 BagelPay 卡片支付',
  'crm.settings.bagelPayEnabledTip':
    '开启后，Web 前端购买弹窗中将出现"使用卡片支付"按钮',
  'crm.settings.currencyConfig': '币种配置',
  'crm.settings.currencyConfigDesc':
    '配置前端可用的支付币种和展示顺序。留空允许列表则展示所有币种。',
  'crm.settings.allowedCurrencies': '允许的币种',
  'crm.settings.allCurrencies': '全部币种',
  'crm.settings.enabledCurrencies': '已启用',
  'crm.settings.allowedCurrenciesTip':
    '留空（右侧为空）= 不限制，展示全部可用币种',
  'crm.settings.pinnedCurrencies': '币种展示顺序',
  'crm.settings.pinnedCurrenciesTip': '使用上下箭头调整币种在前端的展示顺序',
  'crm.settings.system': '系统',
  'crm.settings.support': '客服联系方式',
  'crm.settings.supportConfig': '客服联系方式配置',
  'crm.settings.supportConfigDesc':
    '用于配置 Vite 前端 Contact Support 弹窗中展示的联系方式，关闭或留空的项目不会在前端展示。',
  'crm.settings.supportTelegram': 'Telegram',
  'crm.settings.supportEmail': 'Email',
  'crm.settings.supportWhatsapp': 'WhatsApp',
  'crm.settings.supportEnabled': '启用',
  'crm.settings.supportTelegramUrl': 'Telegram 链接',
  'crm.settings.supportEmailValue': '邮箱地址',
  'crm.settings.supportWhatsappUrl': 'WhatsApp 链接',
  'crm.settings.supportTelegramPaidUrl': '付费用户 Telegram 链接',
  'crm.settings.supportEmailPaidValue': '付费用户邮箱',
  'crm.settings.supportWhatsappPaidUrl': '付费用户 WhatsApp 链接',
  'crm.settings.supportPaidUrlTip':
    '付费用户（存在已完成的购买交易）将跳转到此链接；留空则使用默认链接。',
  'crm.settings.save': '保存',
  'crm.settings.saveChanges': '保存更改',
  // 挖矿设置
  'crm.settings.miningConfig': '挖矿配置',
  'crm.settings.sessionDuration': '挖矿周期（小时）',
  'crm.settings.baseRate': '基础算力收益/小时',
  'crm.settings.withdrawalSettings': '提现设置',
  'crm.settings.minWithdrawBTC': '最低提现 BTC',
  'crm.settings.minWithdrawBLD': '最低提现 BLD',
  'crm.settings.withdrawFeeBTC': 'BTC 提现手续费',
  'crm.settings.withdrawFeeBLD': 'BLD 提现手续费',
  'crm.settings.dailyWithdrawalLimit': '单用户每日提现次数',
  'crm.settings.dailyWithdrawalLimitDesc':
    '按 UTC 自然日统计单个用户已发起的提现次数（含审核中 / 处理中 / 已完成；已被管理员拒绝的不计入）。达到该上限后，用户在 App 端提交提现会被拒绝。填 0 表示不限制。',
  'crm.settings.withdrawNetworkOverrides': '按网络覆盖提现参数',
  'crm.settings.withdrawNetworkOverridesDesc':
    '在下拉框中选择一条提现网络，可单独设置该网络的「最小提现（BTC）」和/或「手续费（BTC）」，会覆盖上方全局配置。App 在用户选择对应网络时使用此处数值。',
  'crm.settings.withdrawNetworkSelect': '提现网络',
  'crm.settings.withdrawNetworkOverrideMin': '最小提现 (BTC)',
  'crm.settings.withdrawNetworkOverrideFee': '手续费 (BTC)',
  'crm.settings.withdrawNetworkApply': '保存该网络配置',
  'crm.settings.withdrawNetworkTableNetwork': '网络',
  'crm.settings.withdrawNetworkTableMin': '最小 (BTC)',
  'crm.settings.withdrawNetworkTableFee': '手续费 (BTC)',
  'crm.settings.withdrawNetworkRemove': '删除',
  'crm.settings.withdrawNetworkPickNetwork': '请选择网络',
  'crm.settings.withdrawNetworkNeedOneField': '请至少填写「最小提现」或「手续费」其中一项',
  // 提现网络
  'crm.settings.withdrawalCurrencies': '提现币种',
  'crm.settings.withdrawalCurrenciesDesc':
    '控制 App 端提现可选择的币种。关闭后该币种不再返回给客户端，已发起的提现请求也会被拒绝。',
  'crm.settings.withdrawCurrencyBTCEnabled': '启用 BTC 提现',
  'crm.settings.withdrawCurrencyUSDTEnabled': '启用 USDT 提现',
  'crm.settings.withdrawalNetworks': '提现网络',
  'crm.settings.withdrawalNetworksDesc':
    '选择用户可以使用的 BTC 和 USDT 提现网络',
  'crm.settings.btcNetworks': 'BTC 提现网络',
  'crm.settings.usdtNetworks': 'USDT 提现网络',
  'crm.settings.btcNetworksRequired': '请至少选择一个 BTC 网络',
  'crm.settings.usdtNetworksRequired': '请至少选择一个 USDT 网络',
  'crm.settings.selectNetworks': '选择网络',
  // 推荐设置
  'crm.settings.referralConfig': '推荐配置',
  'crm.settings.enableReferral': '启用推荐系统',
  'crm.settings.enablePurchaseCommission': '购买商品佣金',
  'crm.settings.enablePurchaseCommissionDesc':
    '关闭后，用户购买矿机/矿场/奖券等商品支付成功时将不再向推荐人发放返佣',
  'crm.settings.enableMiningClaimCommission': '挖矿领取佣金',
  'crm.settings.enableMiningClaimCommissionDesc':
    '关闭后，用户领取挖矿收益时将不再向推荐人发放返佣',
  'crm.settings.commissionRates': '佣金比例',
  'crm.settings.commissionDesc': '各级推荐的佣金比例（百分比）',
  'crm.settings.level1Rate': '一级佣金比例 (%)',
  'crm.settings.level2Rate': '二级佣金比例 (%)',
  'crm.settings.level3Rate': '三级佣金比例 (%)',
  'crm.settings.maxLevels': '最大推荐层级',
  // 分享文案
  'crm.settings.shareTextTitle': '分享文案',
  'crm.settings.shareTextDesc':
    '用户分享邀请链接时使用的文案，支持 {link} 占位符代表邀请链接',
  'crm.settings.shareText': '分享文案',
  'crm.settings.shareTextPlaceholder':
    '例如：加入 CoreX-BTC 开始挖矿赚 BTC！使用我的邀请链接：{link}',
  // 每日奖池设置
  'crm.settings.dailyPoolConfig': '每日奖池配置',
  'crm.settings.enableDailyPool': '启用每日奖池',
  'crm.settings.autoSettle': '自动结算奖励',
  'crm.settings.defaultReward': '默认奖励 (BTC)',
  'crm.settings.minInvites': '最低邀请数',
  // 每日奖池站内信文案
  'crm.settings.messageTemplateTitle': '站内信推送文案',
  'crm.settings.messageTemplateDesc':
    '每日奖池发放奖励时推送给用户的站内信文案，支持 {amount} 和 {currency} 占位符',
  'crm.settings.messageTemplate': '推送文案',
  'crm.settings.messageTemplatePlaceholder':
    '例如：恭喜！您从每日奖池获得了 {amount} {currency} 奖励，继续邀请好友赚取更多！',
  // 社交活动设置
  'crm.settings.socialEventConfig': '社交活动配置',
  'crm.settings.enableTwitter': '启用 Twitter 挑战',
  'crm.settings.enableYoutube': '启用 YouTube 创作者',
  'crm.settings.twitterReward': '每期奖励 (BTC)',
  'crm.settings.youtubeReward': '每期奖励 (BTC)',
  'crm.settings.periodDays': '活动周期（天）',
  // 新用户设置
  'crm.settings.newUser': '新用户配置',
  'crm.settings.newUserConfig': '新用户矿机配置',
  'crm.settings.newUserConfigDesc': '配置新注册用户自动获得的矿机',
  'crm.settings.enableNewUserMiner': '启用新用户矿机',
  'crm.settings.selectNewUserMiner': '选择新用户矿机',
  'crm.settings.selectNewUserMinerPlaceholder': '请选择新用户专属矿机',
  'crm.settings.selectNewUserMinerRequired': '请选择新用户矿机',
  'crm.settings.uploadText': '上传',
  'crm.settings.removeImage': '删除',
  'crm.settings.onlyImageAllowed': '只能上传图片文件',
  'crm.settings.imageTooLarge': '图片大小不能超过5MB',
  'crm.settings.imageUploadSuccess': '图片上传成功',
  'crm.settings.imageUploadFailed': '上传失败',
  'crm.settings.loadFailed': '加载设置失败',
  'crm.settings.saveSuccess': '{section}设置已保存',
  'crm.settings.saveFailed': '保存失败',
  'crm.settings.saveSettingsFailed': '保存设置失败',
  'crm.settings.cacheCleared': '缓存已清除',
  'crm.settings.cacheClearFailed': '清除缓存失败',
  // 社交活动设置
  'crm.settings.enableSocialEvents': '启用社交活动',
  // 社交活动站内信文案
  'crm.settings.socialMessageTemplateTitle': '站内信推送文案',
  'crm.settings.socialMessageTemplateDesc':
    '社交活动发放奖励时推送给用户的站内信文案，支持 {amount} 和 {currency} 占位符',
  'crm.settings.socialMessageTemplate': '推送文案',
  'crm.settings.socialMessageTemplatePlaceholder':
    '例如：恭喜！您因社交媒体贡献获得了 {amount} {currency} 奖励，继续创作优质内容！',
  // 系统信息
  'crm.settings.systemInfo': '系统信息',
  'crm.settings.environment': '环境',
  'crm.settings.version': '版本',
  'crm.settings.apiStatus': 'API 状态',
  'crm.settings.database': '数据库',
  'crm.settings.maintenance': '维护',
  'crm.settings.clearCache': '清除缓存',
  'crm.settings.reindexDb': '重建索引',
  'crm.settings.resetEventPeriods': '重置活动周期',
  'crm.settings.online': '在线',
  'crm.settings.connected': '已连接',
  'crm.settings.disconnected': '未连接',

  // 支付设置 - BSC 钱包 & 对账
  'crm.settings.bscWalletAddress': 'BSC 收款钱包地址',
  'crm.settings.bscWalletAddressTip':
    'BSC 链上的 BEP-20 钱包地址，用于接收 NOWPayments 资金',
  'crm.settings.bscWalletAddressPlaceholder': '0x...',
  'crm.settings.autoReconciliation': '自动对账',
  'crm.settings.autoReconciliationTip':
    '每 10 分钟自动检查钱包余额，异常时自动关闭支付通道',
  'crm.settings.reconciliationInterval': '对账间隔（分钟）',
  'crm.settings.reconciliationIntervalTip': '钱包对账的执行间隔（1-1440 分钟）',
  'crm.settings.reconciliationThreshold': '异常阈值 (%)',
  'crm.settings.reconciliationThresholdTip':
    '钱包余额低于调整后收益的此百分比时触发异常',
  'crm.settings.consecutiveFailLimit': '连续异常次数',
  'crm.settings.consecutiveFailLimitTip': '连续异常次数达到此值后自动关闭支付',

  // 对账管理
  'crm.reconciliation.title': '钱包对账',
  'crm.reconciliation.summary': '对账概览',
  'crm.reconciliation.logs': '对账日志',
  'crm.reconciliation.withdrawals': '提取记录',
  'crm.reconciliation.notConfigured':
    'BSC 钱包地址未配置，请在系统设置 > 支付配置中设置。',
  'crm.reconciliation.walletAddress': '钱包地址',
  'crm.reconciliation.bnbBalance': 'BNB 余额',
  'crm.reconciliation.usdtBalance': 'USDT 余额',
  'crm.reconciliation.walletTotal': '钱包总额 (USDT)',
  'crm.reconciliation.bnbPrice': 'BNB 价格',
  'crm.reconciliation.totalRevenue': '累积总收益',
  'crm.reconciliation.totalWithdrawn': '已提取总额',
  'crm.reconciliation.adjustedRevenue': '调整后收益 (×0.995)',
  'crm.reconciliation.consecutiveAnomalies': '连续异常次数',
  'crm.reconciliation.paymentStatus': '支付通道状态',
  'crm.reconciliation.enabled': '已启用',
  'crm.reconciliation.disabled': '已关闭',
  'crm.reconciliation.triggerManual': '手动对账',
  'crm.reconciliation.triggerSuccess': '对账完成',
  'crm.reconciliation.triggerFailed': '对账失败',
  'crm.reconciliation.refresh': '刷新',
  'crm.reconciliation.time': '时间',
  'crm.reconciliation.walletBalance': '钱包余额',
  'crm.reconciliation.threshold': '阈值',
  'crm.reconciliation.anomaly': '异常',
  'crm.reconciliation.action': '操作',
  'crm.reconciliation.message': '信息',
  'crm.reconciliation.yes': '是',
  'crm.reconciliation.no': '否',
  'crm.reconciliation.actionCheck': '检查',
  'crm.reconciliation.actionAutoDisable': '自动关闭',
  'crm.reconciliation.actionAutoEnable': '自动开启',
  'crm.reconciliation.addWithdrawal': '添加提取记录',
  'crm.reconciliation.amount': '金额',
  'crm.reconciliation.currency': '币种',
  'crm.reconciliation.amountUsdt': '金额 (USDT)',
  'crm.reconciliation.txHash': '交易哈希',
  'crm.reconciliation.note': '备注',
  'crm.reconciliation.delete': '删除',
  'crm.reconciliation.deleteConfirm': '确定要删除此提取记录吗？',
  'crm.reconciliation.addSuccess': '提取记录已添加',
  'crm.reconciliation.addFailed': '添加提取记录失败',
  'crm.reconciliation.deleteSuccess': '提取记录已删除',
  'crm.reconciliation.deleteFailed': '删除提取记录失败',

  // 未匹配支付
  'crm.unmatchedPayments.title': '未匹配支付',
  'crm.unmatchedPayments.list': '支付记录',
  'crm.unmatchedPayments.total': '总计',
  'crm.unmatchedPayments.pendingCount': '待处理',
  'crm.unmatchedPayments.boundCount': '已绑定',
  'crm.unmatchedPayments.ignoredCount': '已忽略',
  'crm.unmatchedPayments.paymentId': '支付ID',
  'crm.unmatchedPayments.paymentStatus': '支付状态',
  'crm.unmatchedPayments.payCurrency': '币种',
  'crm.unmatchedPayments.payAmount': '应付金额',
  'crm.unmatchedPayments.actuallyPaid': '实付金额',
  'crm.unmatchedPayments.priceAmount': '订单金额',
  'crm.unmatchedPayments.payAddress': '付款地址',
  'crm.unmatchedPayments.purchaseId': '购买ID',
  'crm.unmatchedPayments.status': '状态',
  'crm.unmatchedPayments.statusPending': '待处理',
  'crm.unmatchedPayments.statusBound': '已绑定',
  'crm.unmatchedPayments.statusIgnored': '已忽略',
  'crm.unmatchedPayments.createdAt': '接收时间',
  'crm.unmatchedPayments.boundOrderId': '绑定订单',
  'crm.unmatchedPayments.actions': '操作',
  'crm.unmatchedPayments.bind': '绑定订单',
  'crm.unmatchedPayments.ignore': '忽略',
  'crm.unmatchedPayments.delete': '删除',
  'crm.unmatchedPayments.bindTitle': '绑定支付到订单',
  'crm.unmatchedPayments.bindOrderId': '订单号',
  'crm.unmatchedPayments.bindOrderIdPlaceholder':
    '输入订单号（如 ORD20240126...）',
  'crm.unmatchedPayments.bindConfirm':
    '确定将此支付绑定到指定订单？这将完成订单履约，操作不可逆。',
  'crm.unmatchedPayments.bindSuccess': '支付已成功绑定到订单',
  'crm.unmatchedPayments.ignoreTitle': '忽略支付',
  'crm.unmatchedPayments.ignoreNote': '备注（可选）',
  'crm.unmatchedPayments.ignoreNotePlaceholder': '忽略原因...',
  'crm.unmatchedPayments.ignoreSuccess': '已忽略',
  'crm.unmatchedPayments.deleteConfirm': '确定删除此记录？',
  'crm.unmatchedPayments.deleteSuccess': '已删除',
  'crm.unmatchedPayments.outcomeAmount': '输出金额',
  'crm.unmatchedPayments.fee': '手续费',

  // 系统管理 - 账户
  'crm.system.accountList': '管理员列表',
  'crm.system.createAccount': '创建账户',
  'crm.system.editAccount': '编辑账户',
  'crm.system.deleteAccountConfirm': '确定删除此管理员账户？',
  'crm.system.username': '用户名',
  'crm.system.password': '密码',
  'crm.system.newPassword': '新密码',
  'crm.system.role': '角色',
  'crm.system.selectRole': '请选择角色',
  'crm.system.avatar': '头像',
  'crm.system.superAdmin': '超级管理员',
  'crm.system.resetPassword': '重置密码',
  'crm.system.resetPasswordSuccess': '密码重置成功',

  // 系统管理 - 角色
  'crm.system.roleList': '角色列表',
  'crm.system.createRole': '创建角色',
  'crm.system.editRole': '编辑角色',
  'crm.system.deleteRoleConfirm':
    '确定删除此角色？删除前请确保没有账户使用此角色。',
  'crm.system.roleName': '角色名称',
  'crm.system.description': '描述',
  'crm.system.permissions': '权限配置',
  'crm.system.permissionCount': '权限数量',
  'crm.system.adminCount': '关联账户',
  'crm.system.systemRole': '系统角色',

  // 权限树标签
  'crm.perm.dashboard': '仪表盘',
  'crm.perm.dashboard:view': '查看仪表盘',
  'crm.perm.dashboard:edit': '编辑 ROI 成本',
  'crm.perm.users': '用户管理',
  'crm.perm.users:view': '查看用户',
  'crm.perm.users:edit': '编辑用户状态',
  'crm.perm.users:adjustBalance': '调整余额',
  'crm.perm.users:grantMiner': '发放矿机',
  'crm.perm.miners': '矿机管理',
  'crm.perm.miners:view': '查看矿机',
  'crm.perm.miners:create': '创建矿机产品',
  'crm.perm.miners:edit': '编辑矿机产品',
  'crm.perm.miners:delete': '删除矿机产品',
  'crm.perm.orders': '订单管理',
  'crm.perm.orders:view': '查看订单',
  'crm.perm.tickets': '票券管理',
  'crm.perm.tickets:view': '查看票券',
  'crm.perm.tickets:create': '创建票券',
  'crm.perm.tickets:edit': '编辑票券',
  'crm.perm.tickets:delete': '删除票券',
  'crm.perm.withdrawals': '提现管理',
  'crm.perm.withdrawals:view': '查看提现',
  'crm.perm.withdrawals:approve': '审批提现',
  'crm.perm.activities': '活动管理',
  'crm.perm.activities:view': '查看活动',
  'crm.perm.activities:manage': '管理活动',
  'crm.perm.analytics': '数据分析',
  'crm.perm.analytics:view': '查看数据分析',
  'crm.perm.channels': '渠道统计',
  'crm.perm.channels:view': '查看渠道统计',
  'crm.perm.payments': '支付管理',
  'crm.perm.payments:view': '查看支付',
  'crm.perm.payments:manage': '管理支付',
  'crm.perm.reconciliation': '对账管理',
  'crm.perm.reconciliation:view': '查看对账',
  'crm.perm.reconciliation:manage': '管理对账',
  'crm.perm.transactions': '交易记录',
  'crm.perm.transactions:view': '查看交易记录',
  'crm.perm.messages': '站内信管理',
  'crm.perm.messages:view': '查看消息',
  'crm.perm.messages:send': '发送消息',
  'crm.perm.messages:delete': '删除消息',
  'crm.perm.settings': '系统设置',
  'crm.perm.settings:view': '查看设置',
  'crm.perm.settings:edit': '编辑设置',
  'crm.perm.system': '系统管理',
  'crm.perm.system:accounts': '账户管理',
  'crm.perm.system:roles': '角色管理',

  // 促销活动管理
  'crm.promotions.title': '促销活动',
  'crm.promotions.create': '创建促销',
  'crm.promotions.edit': '编辑促销',
  'crm.promotions.name': '活动名称',
  'crm.promotions.product': '目标产品',
  'crm.promotions.discount': '折扣(%)',
  'crm.promotions.requiredQty': '购买数量',
  'crm.promotions.duration': '持续天数',
  'crm.promotions.launchDate': '上线日期',
  'crm.promotions.isActive': '启用状态',
  'crm.promotions.usageCount': '已使用次数',
  'crm.promotions.active': '启用',
  'crm.promotions.inactive': '停用',
  'crm.promotions.deleteConfirm': '确定删除此促销？',
  'crm.promotions.deleteSuccess': '删除成功',
  'crm.promotions.createSuccess': '创建成功',
  'crm.promotions.updateSuccess': '更新成功',
  'crm.promotions.toggleSuccess': '状态已切换',
  'crm.promotions.selectProduct': '选择产品',
  'crm.promotions.namePlaceholder': '如：限时5折购',
  'crm.promotions.discountTip': '输入折扣百分比，如 50 表示打5折',
  'crm.promotions.targetUsers': '目标用户',
  'crm.promotions.targetOld': '老用户',
  'crm.promotions.targetNew': '新用户',
  'crm.promotions.targetAll': '全部用户',
  'crm.promotions.targetUsersTip':
    '老用户：上线日期前注册；新用户：上线日期后注册',
  'crm.promotions.ruleDesc':
    '规则：买 {qty} 台 {product}，享 {discount}% 折扣，每人限1次，注册后 {days} 天内有效',

  // 通用
  'crm.refresh': '刷新',
  'crm.actions': '操作',

  // 行为分析
  'crm.analyticsEvents.title': '行为分析',
  'crm.analyticsEvents.list': '事件流',
  'crm.analyticsEvents.detail': '详情',
  'crm.analyticsEvents.anonymous': '游客',
  'crm.analyticsEvents.loadFailed': '加载失败',
  'crm.analyticsEvents.vsPrev': '环比上期',
  'crm.analyticsEvents.range.today': '今日',
  'crm.analyticsEvents.range.7d': '近 7 天',
  'crm.analyticsEvents.range.30d': '近 30 天',
  'crm.analyticsEvents.kpi.totalPv': '总 PV',
  'crm.analyticsEvents.kpi.totalUv': '总 UV',
  'crm.analyticsEvents.kpi.register': '注册',
  'crm.analyticsEvents.kpi.login': '登录',
  'crm.analyticsEvents.kpi.startClick': '点击开始挖矿',
  'crm.analyticsEvents.kpi.claimClick': '点击领取收益',
  'crm.analyticsEvents.kpi.avgDwell': '平均页面停留',
  'crm.analyticsEvents.trend.title': '事件趋势',
  'crm.analyticsEvents.topPaths.title': '热门页面 (PV)',
  'crm.analyticsEvents.topPaths.path': '路径',
  'crm.analyticsEvents.topPaths.avgDwell': '平均停留',
  'crm.analyticsEvents.column.createdAt': '时间',
  'crm.analyticsEvents.column.eventName': '事件',
  'crm.analyticsEvents.column.user': '用户',
  'crm.analyticsEvents.column.uid': '用户 UID',
  'crm.analyticsEvents.column.pagePath': '页面路径',
  'crm.analyticsEvents.column.dwell': '停留时长',
  'crm.analyticsEvents.column.country': '国家',
  'crm.analyticsEvents.column.ip': 'IP',
  'crm.analyticsEvents.column.referrer': '来源页',
  'crm.analyticsEvents.column.keyword': '关键字 (匿名ID/IP/UA)',
  'crm.analyticsEvents.column.dateRange': '时间范围',
  'crm.analyticsEvents.event.page_view': '页面访问',
  'crm.analyticsEvents.event.page_leave': '页面离开',
  'crm.analyticsEvents.event.user_login': '登录',
  'crm.analyticsEvents.event.user_register_success': '注册成功',
  'crm.analyticsEvents.event.mining_first': '首次挖矿',
  'crm.analyticsEvents.event.mining_start_click': '点击开始挖矿',
  'crm.analyticsEvents.event.mining_claim_click': '点击领取收益',
  // 首页
  'crm.analyticsEvents.event.home_avatar_click': '首页·点击头像打开侧拉栏',
  'crm.analyticsEvents.event.home_btc_balance_click': '首页·点击 BTC 余额',
  'crm.analyticsEvents.event.home_pwa_install_click': '首页·点击 PWA 安装按钮',
  'crm.analyticsEvents.event.home_hashrate_upgrade_click':
    '首页·点击算力 UPGRADE',
  'crm.analyticsEvents.event.home_my_miners_view': '首页·查看矿机详情',
  'crm.analyticsEvents.event.home_add_miner_click': '首页·点击添加矿机',
  // 侧拉栏
  'crm.analyticsEvents.event.drawer_support_click': '侧拉栏·点击 Support',
  'crm.analyticsEvents.event.drawer_language_click': '侧拉栏·点击语言切换',
  // 活动
  'crm.analyticsEvents.event.activity_daily_pool_join_click':
    '活动·每日奖池 Join Now',
  'crm.analyticsEvents.event.activity_share_copy_link_click':
    '活动·Share 弹窗复制链接',
  'crm.analyticsEvents.event.activity_share_platform_click':
    '活动·Share 弹窗平台分享',
  'crm.analyticsEvents.event.activity_install_reward_claim_click':
    '活动·安装奖励领取',
  // 市场
  'crm.analyticsEvents.event.market_buy_now_click': '市场·点击 Buy Now',
  'crm.analyticsEvents.event.market_confirm_qty_increase_click':
    '市场·下单弹窗增加数量',
  'crm.analyticsEvents.event.market_confirm_payment_method_select':
    '市场·下单弹窗选择支付方式',
  'crm.analyticsEvents.event.market_confirm_continue_click':
    '市场·下单弹窗继续支付',
  'crm.analyticsEvents.event.market_swiper_next_click':
    '市场·矿机轮播右侧三箭头切换',
  // 团队
  'crm.analyticsEvents.event.team_how_commission_click':
    '团队·How Commission Works',
  'crm.analyticsEvents.event.team_copy_link_click': '团队·复制邀请链接',
  'crm.analyticsEvents.event.team_share_click': '团队·分享按钮',
  'crm.analyticsEvents.event.team_level_select': '团队·等级切换',
  // 资产
  'crm.analyticsEvents.event.assets_withdraw_click': '资产·点击提现',

  // 用户详情·行为 Tab
  'crm.users.behaviorTab': '行为',
};
